import React from 'react';
import { Svg, Path } from 'react-native-svg';

interface ImageIconProps {
  size?: number;
  color?: string;
}

const ImageIcon: React.FC<ImageIconProps> = ({ 
  size = 28, 
  color = "#6300A3" 
}) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 28 28" fill="none">
      <Path 
        d="M5.83333 12.95L8.16667 10.6167L14.5833 17.0333L18.6667 12.95L22.1667 16.45V5.83333H5.83333V12.95ZM4.66667 3.5H23.3333C23.6428 3.5 23.9395 3.62292 24.1583 3.84171C24.3771 4.0605 24.5 4.35725 24.5 4.66667V23.3333C24.5 23.6428 24.3771 23.9395 24.1583 24.1583C23.9395 24.3771 23.6428 24.5 23.3333 24.5H4.66667C4.35725 24.5 4.0605 24.3771 3.84171 24.1583C3.62292 23.9395 3.5 23.6428 3.5 23.3333V4.66667C3.5 4.35725 3.62292 4.0605 3.84171 3.84171C4.0605 3.62292 4.35725 3.5 4.66667 3.5ZM18.0833 11.6667C17.6192 11.6667 17.1741 11.4823 16.8459 11.1541C16.5177 10.8259 16.3333 10.3808 16.3333 9.91667C16.3333 9.45254 16.5177 9.00742 16.8459 8.67923C17.1741 8.35104 17.6192 8.16667 18.0833 8.16667C18.5475 8.16667 18.9926 8.35104 19.3208 8.67923C19.649 9.00742 19.8333 9.45254 19.8333 9.91667C19.8333 10.3808 19.649 10.8259 19.3208 11.1541C18.9926 11.4823 18.5475 11.6667 18.0833 11.6667Z" 
        fill={color}
      />
    </Svg>
  );
};

export default ImageIcon;
